<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择认证类型',ischange:true,width:'200px',clearable:true,filterable:true}" 
                :value="param.isauth"
                :list="memberauthtypes"
                @finish="(val)=> {
                    param.isauth=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择会员类型',ischange:true,width:'200px',clearable:true,filterable:true}" 
                :value="param.iscompany"
                :list="typelists"
                @finish="(val)=> {
                    param.iscompany=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择会员标签',ischange:true,width:'200px',clearable:true,filterable:true}" 
                :value="param.is_robot"
                :list="labellists"
                @finish="(val)=> {
                    param.is_robot=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'请输入会员名称',clearable:true,ischange:true,isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'新增会员'}" @finish="AddMember"/>
        </el-form-item>
        <el-form-item>
        <wcbutton 
            :option="{title:'取消选择',type:'del'}" 
            v-if="childhandleparam.type=='selectmember'"
            @finish="(val)=> {
                childhandleparam.type='';
                childhandleparam.rollbackindex='';
                childhandleparam.rollbackobjname='';
            }" 
        />
        </el-form-item>
    </el-form>
</div>


<!-- 一级数据操作 -->
<div class="TTL-table top20" :ref="objloading" v-if="!param.isorder">
    <el-table :data="list" stripe="true" empty-text="" @selection-change="selecttable">
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column type="selection" />
        <el-table-column label="会员头像" align="center">
            <template #default="scope">
                <wcimage :option="{size:'middle'}" :value="scope.row.thumb" />
            </template>
        </el-table-column>
        <el-table-column label="会员名称" align="center">
            <template #default="scope">
                <div class="TTL-username" 
                    @click="(val)=> {
                        this.detailparam.id=scope.row.id;
                        this.detailparam.view=true;
                    }"
                >
                    <span>{{scope.row.name}}</span>
                    <span v-if="scope.row.is_robot==2">（系统机器人）</span>
                    <span v-if="scope.row.is_robot==3">（外卖骑手）</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机" align="center"/>
        <el-table-column label="认证情况" align="center">
            <template #default="scope">
                <span class="TTL-username" @click="ShowMemberAuth(scope.row.id,scope.row.authinfo)">
                    {{scope.row.auth_name}}
                    <h v-if="scope.row.auth_id > 0">{{'，'+scope.row.auth_status_name}}</h>
                </span>
            </template>
        </el-table-column>
        <el-table-column label="vip" align="center">
            <template #default="scope">
                <span class="TTL-username" @click="ShowMemberVip(scope.row.id,scope.row.vipinfo)">
                    {{scope.row.vipinfo.isvip? '已开通':'未开通'}}
                </span>
            </template>
        </el-table-column>
        <el-table-column label="余额" align="center">
            <template #default="scope">
                <span class="TTL-username" 
                    @click="(val) => {
                        this.walletshow.view=true;
                        this.walletshow.memberid=scope.row.id;
                    }"
                >{{scope.row.wallets}}
                </span>
            </template>
        </el-table-column>
        <el-table-column prop="sales" label="发布宠物" align="center"/>
        <!-- <el-table-column prop="buys" label="发布(求购)" align="center"/> -->
        <el-table-column prop="inputtime" label="添加时间" align="center"/>
        <!-- <el-table-column label="是否被冻结" align="center">
            <template #default="scope">
                <div class="ttl-frozen">
                <el-tooltip placement="top" v-if="scope.row.isfrozen==1 || scope.row.isfrozen==2">
                <template #content>
                    {{scope.row.frozen_reason}}<br />
                    <span v-if="scope.row.frozen_time!=''">{{'冻结结束时间：'+scope.row.frozen_time}}</span>
                </template>
                <el-image :src="scope.row.isfrozen==1 ? require('@/assets/icon/wrong.png') : require('@/assets/icon/warning.png') " />
                </el-tooltip>
                <span>{{scope.row.isfrozen==0 ? '/' : scope.row.isfrozen==1 ? '被冻结' : '被举报'}}</span>
                </div>
            </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" min-width="180" fixed="right">
            <template #default="scope">
            <div class="TTL-btn-info">
            <wcbutton :option="{title:'编辑',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsEditMember',param:{ids:scope.row.id}})" class="right10" v-if="childhandleparam.type==''"/>
            <wcbutton :option="{title:'编辑认证',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsEditAuth',param:{id:scope.row.id}})" class="right10" />
            <wcbutton :option="{title:'冻结',type:'del'}" @finish="EditMemberStatus(scope.row)" v-if="(scope.row.isfrozen==0 || scope.row.isfrozen==2) && childhandleparam.type==''"/>
            <wcbutton :option="{title:'解冻',type:'del'}" @finish="EditMemberStatus(scope.row)" v-if="scope.row.isfrozen==1 && childhandleparam.type==''"/>
            <wcbutton 
                :option="{title:'选择会员'}" 
                v-if="childhandleparam.type=='selectmember'"
                @finish="(val)=> {
                    $parent.JUMPVIEW({name:childhandleparam.rollbackobjname,param:{type:childhandleparam.type,index:childhandleparam.rollbackindex,data:scope.row}})
                    childhandleparam.type='';
                    childhandleparam.rollbackindex='';
                    childhandleparam.rollbackobjname='';
                }" 
            />
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-select TTL-page-left">
            <wcselect :option="{placeholder:'请选择操作',ischange:true,isconfim:true}" 
                :value="handlevalue"
                :list="handleinfos"
                @finish="(val)=> {
                    changehandle(val.value)
                }"
            />
        </div>
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>

<!-- 认证信息 -->
<AuthShow :view="authshow.view" :memberid="authshow.memberid" :data="authshow.data" @finish="(val)=> {this.authshow.view=false;}" />
<!-- 会员信息详情 -->
<MemberInfoShow :view="detailparam.view" :id="detailparam.id" @finish="(val)=> {this.detailparam.view=false;}" /> 
<!-- vip信息 -->
<VipSetting :view="vipshow.view" :memberid="vipshow.memberid" :data="vipshow.data" 
    @finish="(val)=> {
        this.vipshow.view=false;
        this.GetList();
    }" 
/>

<!-- 余额日志 -->
<MembersWalletLogs :view="walletshow.view" :memberid="walletshow.memberid" @finish="(val)=> {this.walletshow.view=false}"/>

</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
import AuthShow from '@/views/EsMembers/Module/AuthShow';
import VipSetting from '@/views/EsMembers/Module/VipSetting';
import MemberInfoShow from '@/views/EsMembers/MemberInfoShow';
import MembersWalletLogs from '@/views/EsMembers/MembersWalletLogs';
export default {

    components:{
        AuthShow,MemberInfoShow,VipSetting,MembersWalletLogs
    },

    data() {
        return {
            objloading:'member',
            param: {
                key:'',
                isauth:'',
                iscompany:'',
                is_robot:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            typelists:[],
            labellists:[],
            memberauthtypes:[],
            list:[],
            handlevalue:'',
            handleinfos:[
                //{id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],

            //兄弟组件操作参数
            childhandleparam: {
                type:'',
                rollbackobjname:'',
                rollbackindex:'',
            },
            authshow:{
                view:false,
                memberid:'',
                data:'',
            },
            detailparam: {
                view:false,
                id:'',
            },
            vipshow:{
                view:false,
                memberid:'',
                data:'',
            },
            walletshow: {
                view:false,
                memberid:'',
            }

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
            this.GetMemberTypes(isfresh);
            this.GetMemberLabels(isfresh);
            this.GetMemberAuthTypes(isfresh);
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                if(data.param) {
                    for(var i in data.param) {
                        this.param[i]=data.param[i];
                    }
                }
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                if(data.param) {
                    for(var i in data.param) {
                        this.param[i]=data.param[i];
                        this.GetList();
                    }
                }

            }


            //兄弟元素操作
            if(data.param.childtype && data.param.childtype!='') {
                this.childhandleparam.type=data.param.childtype;
                this.childhandleparam.rollbackindex=data.param.rollbackindex;
                this.childhandleparam.rollbackobjname=data.param.rollbackobjname;
            }

        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.list.length;i++) this.list[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(val);
        },


        /** 批量操作 **/
        changehandle(index) {
            var ids=this.GetSelectDataIds(); //获取当前选中的id
            if(ids.length==0) {this.$notice({title:'消息提示',message:'请选择要批量执行的数据',type:'warning'});return false;}
            ids=ids.join(',');
            //if(index==1) this.delgoods(ids);    //批量删除
            if(index==2) this.$parent.JUMPVIEW({name:'EsEditMember',param:{ids:ids}})

        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.list.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },



        /** 显示认证信息 **/
        ShowMemberAuth(memberid,authinfo) {
            this.authshow.view=true;
            this.authshow.memberid=memberid;
            this.authshow.data=authinfo;
        },


        /** 显示vip开通信息 **/
        ShowMemberVip(memberid,vipinfo) {
            this.vipshow.view=true;
            this.vipshow.memberid=memberid;
            this.vipshow.data=vipinfo;
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MEMBER.GET_MEMBER_LIST(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 获取会员类型信息 **/
        GetMemberTypes(isfresh) {
            this.$method.GET_MEMBER_TYPES(isfresh).then((res) => {this.typelists=res;console.log(res)});
        },


        /** 获取会员标签信息 **/
        GetMemberLabels(isfresh) {
            this.$method.GET_MEMBER_SYS_TYPE(isfresh).then((res) => {this.labellists=res;console.log(res)});
        },

        /** 获取会员认证类型 **/
        GetMemberAuthTypes(isfresh) {
            this.$method.GET_MEMBER_AUTH_TYPES(isfresh).then((res) => {this.memberauthtypes=res;console.log(res)});
        },

        
        /** 冻结、解冻会员 **/
        EditMemberStatus(member) {
            var id=member.id;
            var isfrozen=member.isfrozen;
            if(isfrozen==0 || isfrozen==2) this.$parent.JUMPVIEW({name:'EsFrozenMember',param:{id:id,pid:0,name:member.name,phone:member.phone,thumb:member.thumb}}); //冻结会员
            if(isfrozen==1) this.$parent.JUMPVIEW({name:'EsUnFrozenMember',param:{id:id,name:member.name,phone:member.phone,thumb:member.thumb}}); //解冻会员
        },


        /** 新增会员信息 **/
        AddMember() {
            this.$parent.JUMPVIEW({name:'EsAddMember',param:{}});
        },



    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.TTL-username {color:#666eeb;cursor: pointer;}
.TTL-username span {display: inline-block;width:100%;}
</style>